//--------------------------------------------
//
// Particles shooting out
//
//--------------------------------------------
'use strict';

import THREE from 'three';

const OculusParticles = (s) => {

	const self = this;
	const scene = s;
	const particles = [];

	const material = new THREE.SpriteMaterial({
		map: new THREE.CanvasTexture(generateSprite()),
		blending: THREE.AdditiveBlending,
		opacity:0.6
	});


	for (let i = 0; i < 10; i++ ){
		const particle = new THREE.Sprite(material);
		initParticle(particle, i * 10);
		particles.push(particle);
		scene.add(particle);

	}



	function generateSprite(){

		const canvas = document.createElement('canvas');
		canvas.width = 16;
		canvas.height = 16;

		const ctx = canvas.getContext('2d');
		const gradient = ctx.createRadialGradient(
			canvas.width / 2,
			canvas.height / 2,
			0,
			canvas.width / 2,
			canvas.height / 2,
			canvas.width / 2
		);

		gradient.addColorStop(0, 'rgba(255,255,255,1)');
		gradient.addColorStop(0.2, 'rgba(255,0,0,1)');
		gradient.addColorStop(0.4, 'rgba(0,0,64,1)');
		gradient.addColorStop(1, 'rgba(0,0,0,1)');

		ctx.fillStyle = gradient;
		ctx.fillRect(0, 0, canvas.width, canvas.height);

		return canvas;

	}


	function initParticle(p, d){
		const particle = this instanceof THREE.Sprite ? this : p;
		const delay = delay !== undefined ? d : 0;

		particle.position.set(0,0,-100);
		particle.scale.x = particle.scale.y = Math.random() * 32 + 16;
	}

	return particles;


}


export default OculusParticles;